// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationParameterTypeId } from './FermentationParameterType';
import { fermentationLineTypeId } from './FermentationLineType';
import { operatorId } from './Operator';
import { z } from 'zod';
export const tankBoardColumnId = (z.number());
export const tankBoardColumn = z.object({
    id: tankBoardColumnId,
    parameter_type_id: fermentationParameterTypeId.nullable(),
    line_type_id: fermentationLineTypeId.nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    show_sterilization: z.boolean(),
});
export const tankBoardColumnInitializer = z.object({
    id: tankBoardColumnId.optional(),
    parameter_type_id: fermentationParameterTypeId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    display_order: z.number(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    show_sterilization: z.boolean().optional(),
});
export const tankBoardColumnMutator = z.object({
    id: tankBoardColumnId.optional(),
    parameter_type_id: fermentationParameterTypeId.optional().nullable(),
    line_type_id: fermentationLineTypeId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    show_sterilization: z.boolean().optional(),
});
//# sourceMappingURL=TankBoardColumn.js.map